// WILLYFACE1 (docs/build-briefs/WILLYFACE1-chat-avatars.md; DEC-591): the round faces in the Willy chat. Willy is an original
// cartoon barkeep drawn for this product: a handlebar mustache, a bow tie and a wink. Every color is a theme token, so the face
// follows each theme, dark ones included. The drawing is decoration (aria-hidden); the name beside it carries the meaning.

import { personInitials } from "./willyModel.ts";

const SVG_NS = "http://www.w3.org/2000/svg";

/** A fixed, trusted drawing (no input reaches it). Filled and stroked only through token variables. */
const WILLY_FACE_SVG = `<svg viewBox="0 0 64 64" xmlns="${SVG_NS}" aria-hidden="true" focusable="false">
<rect width="64" height="64" style="fill:var(--color-surface-sunken)"/>
<path d="M6 64C8 52 18 49 32 49S56 52 58 64Z" style="fill:var(--color-text-primary)"/>
<path d="M25 49L32 56L39 49Z" style="fill:var(--color-surface)"/>
<path d="M32 55L21 50V60ZM32 55L43 50V60Z" style="fill:var(--color-accent-strong)"/>
<rect x="29.5" y="52.5" width="5" height="5" rx="1.5" style="fill:var(--color-accent-strong);stroke:var(--color-text-primary);stroke-width:1"/>
<ellipse cx="32" cy="30" rx="15" ry="17" style="fill:var(--color-accent-subtle-border);stroke:var(--color-text-primary);stroke-width:2"/>
<path d="M19 22C20 13 28 10 32 10S44 13 45 22C41 17 37 16 32 16S23 17 19 22Z" style="fill:var(--color-text-primary)"/>
<circle cx="25.5" cy="30" r="2.2" style="fill:var(--color-text-primary)"/>
<path d="M36.5 30.5Q39 27.5 41.5 30.5" style="fill:none;stroke:var(--color-text-primary);stroke-width:2;stroke-linecap:round"/>
<circle cx="22" cy="35" r="2.6" style="fill:var(--color-danger-subtle-border);opacity:0.7"/>
<circle cx="42" cy="35" r="2.6" style="fill:var(--color-danger-subtle-border);opacity:0.7"/>
<path d="M32 36.5C29 33.5 23 34 21 38C20 40.500 22.500 42 24 40.500C25.500 39 27 39.500 29 40.500C30.500 41.200 31.300 41 32 40.500C32.700 41 33.500 41.200 35 40.500C37 39.500 38.500 39 40 40.500C41.500 42 44 40.500 43 38C41 34 35 33.500 32 36.500Z" style="fill:var(--color-text-primary)"/>
<path d="M21 38C17 38 16.500 42.500 19.500 43" style="fill:none;stroke:var(--color-text-primary);stroke-width:1.600;stroke-linecap:round"/>
<path d="M43 38C47 38 47.500 42.500 44.500 43" style="fill:none;stroke:var(--color-text-primary);stroke-width:1.600;stroke-linecap:round"/>
<path d="M27.500 44.500Q32 48.500 36.500 44.500" style="fill:none;stroke:var(--color-text-primary);stroke-width:1.800;stroke-linecap:round"/>
</svg>`;

/** The neutral stand-in when a name is unknown, so a circle is never empty. */
const PERSON_GLYPH_SVG = `<svg viewBox="0 0 24 24" xmlns="${SVG_NS}" aria-hidden="true" focusable="false">
<circle cx="12" cy="9" r="4" style="fill:currentColor"/>
<path d="M4 21C4 16.500 8 14.500 12 14.500S20 16.500 20 21Z" style="fill:currentColor"/>
</svg>`;

/** Willy's round face. `size` is the diameter in px (32 in a message, 40 in the header). */
export function willyAvatar(size: 32 | 40): HTMLElement {
  const frame = document.createElement("span");
  frame.className = `willy-avatar willy-avatar-willy willy-avatar-${size}`;
  frame.setAttribute("aria-hidden", "true");
  frame.dataset["testid"] = "willy-avatar";
  frame.innerHTML = WILLY_FACE_SVG;
  return frame;
}

/** The signed-in person's round initials (first and last), or a neutral person glyph when no name is known. */
export function personAvatar(name: string, size: 32 | 40 = 32): HTMLElement {
  const frame = document.createElement("span");
  frame.className = `willy-avatar willy-avatar-person willy-avatar-${size}`;
  frame.setAttribute("aria-hidden", "true");
  frame.dataset["testid"] = "willy-person-avatar";
  const initials = personInitials(name);
  if (initials === "") frame.innerHTML = PERSON_GLYPH_SVG;
  else frame.textContent = initials;
  return frame;
}
